import EventRegistrationForm from './EventRegistrationForm';

export default EventRegistrationForm;
